const IconDict = {
  "icon-arrow_left": (
    <path
      d="M17 3L8 12L17 21"
      stroke="current"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  "icon-arrow_right": (
    <path
      d="M8 3L17 12L8 21"
      stroke="#6B7280"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  "icon-arrow_right_14": (
    <path
      d="M4 2L10 7L4 12"
      stroke="#6B7280"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 14 14"
    />
  ),
  "icon-arrow_up": (
    <path
      d="M3 16L12 7L21 16"
      stroke="#6B7280"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  "icon-arrow_down": (
    <path
      d="M21 7L12 16L3 7"
      stroke="#6B7280"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  "icon-check": (
    <path
      d="M3 12L9 18L21 6"
      stroke="#6B7280"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  "icon-x": (
    <path
      d="M5.64681 4.27946C5.27008 3.90685 4.65928 3.90685 4.28255 4.27946C3.90582 4.65207 3.90582 5.25619 4.28255 5.6288L10.7242 12L4.28255 18.3712C3.90582 18.7438 3.90582 19.3479 4.28255 19.7205C4.65928 20.0932 5.27008 20.0932 5.64681 19.7205L12.0885 13.3493L18.3532 19.5455C18.7299 19.9181 19.3407 19.9181 19.7175 19.5455C20.0942 19.1729 20.0942 18.5688 19.7175 18.1962L13.4527 12L19.7175 5.80383C20.0942 5.43122 20.0942 4.8271 19.7175 4.45449C19.3407 4.08188 18.7299 4.08188 18.3532 4.45449L12.0885 10.6507L5.64681 4.27946Z"
      fill="#6B7280"
    />
  ),
  "icon-trash_can-stroke": (
    <>
      <path
        d="M10.3432 9.03243C10.7574 9.03243 11.0932 9.3537 11.0932 9.75V15.7419C11.0932 16.1382 10.7574 16.4595 10.3432 16.4595C9.929 16.4595 9.59322 16.1382 9.59322 15.7419L9.59322 9.75C9.59322 9.3537 9.929 9.03243 10.3432 9.03243Z"
        fill="#6B7280"
      />
      <path
        d="M14.6864 9.75C14.6864 9.3537 14.3507 9.03243 13.9364 9.03243C13.5222 9.03243 13.1864 9.3537 13.1864 9.75V15.7419C13.1864 16.1382 13.5222 16.4595 13.9364 16.4595C14.3507 16.4595 14.6864 16.1382 14.6864 15.7419V9.75Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4.49189H20L19.993 4.57297H20C20.5523 4.57297 21 5.00133 21 5.52973C21 6.05813 20.5523 6.48649 20 6.48649H19.8292L18.7367 19.2428C18.6516 20.2356 17.7846 21 16.7433 21H7.52783C6.48659 21 5.61954 20.2356 5.53451 19.2428L4.44201 6.48649H4C3.44772 6.48649 3 6.05813 3 5.52973C3 5.00133 3.44772 4.57297 4 4.57297H4.27812L4.27118 4.49189H9C9 3.47368 10.0468 3 11 3H14C14.9532 3 16 3.47368 16 4.49189ZM7.52783 19.0865L6.44871 6.48649H17.8225L16.7433 19.0865H7.52783Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-heart-stroke": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9702 4.47293C9.58414 2.46275 6.0222 2.58464 3.77877 4.8386C1.40708 7.22143 1.40708 11.0848 3.77877 13.4676L10.7803 20.502C11.4412 21.166 12.5128 21.166 13.1738 20.502L17.4425 16.2132C17.4888 16.1667 17.5337 16.1196 17.5774 16.0716L20.2214 13.4153C22.5929 11.0326 22.5929 7.16961 20.2214 4.78698C17.9591 2.51408 14.356 2.40939 11.9702 4.47293ZM16.1325 14.6816L18.8072 11.9944C20.3976 10.3965 20.3976 7.80575 18.8072 6.20783C17.2906 4.68414 14.8735 4.61316 13.275 5.99575L11.9872 7.10961L10.6851 6.01263C9.08647 4.66581 6.69685 4.74853 5.19298 6.25946C3.60234 7.85757 3.60234 10.4486 5.19298 12.0467L11.977 18.8626L16.0283 14.7923C16.0541 14.7665 16.079 14.7403 16.1032 14.7138L16.1325 14.6816Z"
      fill="#6B7280"
    />
  ),
  "icon-heart-filled": (
    <path
      d="M17.5774 16.0716C17.5337 16.1196 17.4888 16.1667 17.4425 16.2132L13.1738 20.502C12.5128 21.166 11.4412 21.166 10.7803 20.502L3.77877 13.4676C1.40708 11.0848 1.40708 7.22143 3.77877 4.8386C6.0222 2.58464 9.58414 2.46275 11.9702 4.47293C14.356 2.40939 17.9591 2.51408 20.2214 4.78698C22.5929 7.16961 22.5929 11.0326 20.2214 13.4153L17.5774 16.0716Z"
      fill="#6B7280"
    />
  ),
  "icon-search": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8483 18.1881C15.3897 19.3549 13.5395 20.0526 11.5263 20.0526C6.81736 20.0526 3 16.2353 3 11.5263C3 6.81736 6.81736 3 11.5263 3C16.2353 3 20.0526 6.81736 20.0526 11.5263C20.0526 13.5395 19.3549 15.3897 18.1881 16.8483L20.7225 19.3827C21.0925 19.7527 21.0925 20.3526 20.7225 20.7225C20.3526 21.0925 19.7527 21.0925 19.3827 20.7225L16.8483 18.1881ZM18.1579 11.5263C18.1579 15.1888 15.1888 18.1579 11.5263 18.1579C7.8638 18.1579 4.89474 15.1888 4.89474 11.5263C4.89474 7.8638 7.8638 4.89474 11.5263 4.89474C15.1888 4.89474 18.1579 7.8638 18.1579 11.5263Z"
      fill="#6B7280"
    />
  ),
  "icon-three_dots": (
    <>
      <circle cx="12" cy="12" r="2" fill="#6B7280" />
      <circle cx="19" cy="12" r="2" fill="#6B7280" />
      <circle cx="5" cy="12" r="2" fill="#6B7280" />
    </>
  ),
  "icon-bell-stroke": (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0006 5.09476L11.3371 5.15078C9.83833 5.27733 8.74735 5.83487 7.97919 6.64658C7.18715 7.48355 6.65147 8.68852 6.5246 10.1817C6.24339 13.4916 5.64883 16.1387 5.45468 16.9445C5.41815 17.0961 5.36965 17.2423 5.31076 17.3828C9.60151 17.1599 14.3957 17.1599 18.6863 17.3829C18.6233 17.2315 18.5725 17.0738 18.5356 16.9106C18.3504 16.0911 17.7798 13.4116 17.4714 10.1995C17.1923 7.2909 15.4203 5.39207 12.6515 5.15135L12.0006 5.09476ZM13.1996 3.37006C17.0268 3.85106 19.1947 6.64292 19.5211 10.0443C19.8204 13.1621 20.3755 15.7678 20.5525 16.551C20.5888 16.7117 20.658 16.863 20.7552 17.0022C21.4614 18.0141 20.5459 19.3196 19.2082 19.242C14.63 18.9763 9.37794 18.976 4.79845 19.2413C3.45574 19.3191 2.5369 18.0086 3.24576 16.9929C3.33872 16.8598 3.40615 16.7155 3.44307 16.5622C3.62581 15.8038 4.20146 13.2437 4.47329 10.0443C4.76921 6.56127 6.96234 3.83587 10.7948 3.36794C10.8603 3.35995 10.9262 3.35262 10.9925 3.34596C11.0381 3.34138 11.0839 3.33712 11.13 3.33317C11.1341 3.33282 11.1383 3.33246 11.1424 3.33211V2.7591C11.1424 2.33986 11.5251 2 11.9972 2C12.4693 2 12.852 2.33986 12.852 2.75909V3.33317C12.9018 3.33751 12.9515 3.34223 13.0008 3.34733C13.0676 3.35422 13.1338 3.3618 13.1996 3.37006Z"
        fill="#6B7280"
      />
      <path
        d="M9.27883 20.1773C9.19812 19.9247 9.43059 19.6963 9.72614 19.6908C11.2335 19.663 12.761 19.663 14.2683 19.6908C14.5639 19.6963 14.7964 19.9247 14.7157 20.1773C14.3794 21.2294 13.2897 22 11.9972 22C10.7048 22 9.61505 21.2294 9.27883 20.1773Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-refresh": (
    <>
      <path
        d="M8.30333 4.90531C9.9889 4.02705 11.9321 3.7776 13.7848 4.20164C15.0034 4.48055 16.1305 5.03881 17.0825 5.82192L15.9489 7.08444C15.3871 7.71009 15.8013 8.70759 16.6411 8.7512L20.7535 8.96475C21.3894 8.99776 21.8938 8.43604 21.7927 7.8074L21.1392 3.74155C21.0058 2.91136 19.9696 2.60649 19.4078 3.23214L18.4197 4.33266C17.2158 3.32476 15.7828 2.60721 14.231 2.25205C11.9151 1.722 9.48612 2.03381 7.37917 3.13164C5.27221 4.22946 3.62494 6.04157 2.73244 8.24337C1.83993 10.4452 1.7605 12.8928 2.50837 15.1478C3.25623 17.4029 4.78254 19.318 6.81388 20.5501C8.84522 21.7822 11.2489 22.2509 13.5943 21.8721C15.9397 21.4933 18.0737 20.2919 19.6139 18.4829C21.1541 16.674 22 14.3758 22 12C22 11.4477 21.5523 11 21 11C20.4477 11 20 11.4477 20 12C20 13.9006 19.3233 15.7392 18.0911 17.1863C16.8589 18.6335 15.1518 19.5947 13.2754 19.8977C11.3991 20.2007 9.47618 19.8258 7.85111 18.8401C6.22603 17.8544 5.00499 16.3223 4.40669 14.5183C3.8084 12.7142 3.87195 10.7561 4.58595 8.99469C5.29996 7.23325 6.61777 5.78357 8.30333 4.90531Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-check-stroke-circled": (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3522 8.53189C17.7488 8.91624 17.7587 9.54933 17.3744 9.94593L11.4385 16.0709C11.0643 16.4571 10.4516 16.4782 10.0518 16.1186L6.36257 12.8008C5.95192 12.4315 5.9184 11.7993 6.2877 11.3886C6.657 10.978 7.28928 10.9444 7.69993 11.3137L10.6728 13.9872L15.9381 8.55407C16.3225 8.15747 16.9556 8.14754 17.3522 8.53189Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-check-filled-circled": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.3744 9.94593C17.7587 9.54933 17.7488 8.91624 17.3522 8.53189C16.9556 8.14754 16.3225 8.15747 15.9381 8.55407L10.6728 13.9872L7.69993 11.3137C7.28928 10.9444 6.657 10.978 6.2877 11.3886C5.9184 11.7993 5.95192 12.4315 6.36257 12.8008L10.0518 16.1186C10.4516 16.4782 11.0643 16.4571 11.4385 16.0709L17.3744 9.94593Z"
      fill="#6B7280"
    />
  ),
  "icon-x-stroke-circled": (
    <>
      <path
        d="M16.3241 7.65625C15.9336 7.26573 15.3005 7.26573 14.9099 7.65625L12 10.5662L9.09007 7.65625C8.69955 7.26573 8.06638 7.26573 7.67586 7.65625C7.28534 8.04677 7.28534 8.67994 7.67586 9.07046L10.5858 11.9804L7.63664 14.9295C7.24612 15.3201 7.24612 15.9532 7.63664 16.3438C8.02717 16.7343 8.66033 16.7343 9.05086 16.3438L12 13.3946L14.9491 16.3438C15.3397 16.7343 15.9728 16.7343 16.3634 16.3438C16.7539 15.9532 16.7539 15.3201 16.3634 14.9295L13.4142 11.9804L16.3241 9.07046C16.7147 8.67994 16.7147 8.04677 16.3241 7.65625Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-x-filled-circled": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.3241 7.65625C15.9336 7.26573 15.3005 7.26573 14.9099 7.65625L12 10.5662L9.09007 7.65625C8.69955 7.26573 8.06638 7.26573 7.67586 7.65625C7.28534 8.04677 7.28534 8.67994 7.67586 9.07046L10.5858 11.9804L7.63664 14.9295C7.24612 15.3201 7.24612 15.9532 7.63664 16.3438C8.02717 16.7343 8.66033 16.7343 9.05086 16.3438L12 13.3946L14.9491 16.3438C15.3397 16.7343 15.9728 16.7343 16.3634 16.3438C16.7539 15.9532 16.7539 15.3201 16.3634 14.9295L13.4142 11.9804L16.3241 9.07046C16.7147 8.67994 16.7147 8.04677 16.3241 7.65625Z"
      fill="#6B7280"
    />
  ),
  "icon-upload": (
    <>
      <path
        d="M12 3L17.8804 8.62812C18.2504 8.98222 18.2504 9.55633 17.8804 9.91042C17.5104 10.2645 16.9106 10.2645 16.5406 9.91042L12.9474 6.47132V14.8513C12.9474 15.3521 12.5232 15.758 12 15.758C11.4768 15.758 11.0526 15.3521 11.0526 14.8513V6.47132L7.45936 9.91042C7.08939 10.2645 6.48955 10.2645 6.11958 9.91042C5.74961 9.55633 5.74961 8.98222 6.11958 8.62812L12 3Z"
        fill="#6B7280"
      />
      <path
        d="M3.94737 12.4428C4.47059 12.4428 4.89474 12.8488 4.89474 13.3495V18.2798C4.89474 18.7806 5.31889 19.1866 5.84211 19.1866H18.1579C18.6811 19.1866 19.1053 18.7806 19.1053 18.2798V13.3495C19.1053 12.8488 19.5294 12.4428 20.0526 12.4428C20.5758 12.4428 21 12.8488 21 13.3495V18.2798C21 19.7821 19.7275 21 18.1579 21H5.84211C4.27245 21 3 19.7821 3 18.2798V13.3495C3 12.8488 3.42415 12.4428 3.94737 12.4428Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-download": (
    <>
      <path
        d="M12 15.758L6.11958 10.1299C5.74961 9.77579 5.74961 9.20168 6.11958 8.84759C6.48955 8.49349 7.0894 8.49349 7.45936 8.84759L11.0526 12.2867V3.90672C11.0526 3.40595 11.4768 3 12 3C12.5232 3 12.9474 3.40595 12.9474 3.90672V12.2867L16.5406 8.84759C16.9106 8.49349 17.5104 8.49349 17.8804 8.84759C18.2504 9.20168 18.2504 9.77579 17.8804 10.1299L12 15.758Z"
        fill="#6B7280"
      />
      <path
        d="M3.94737 12.4428C4.47059 12.4428 4.89474 12.8488 4.89474 13.3495V18.2798C4.89474 18.7806 5.31889 19.1866 5.84211 19.1866H18.1579C18.6811 19.1866 19.1053 18.7806 19.1053 18.2798V13.3495C19.1053 12.8488 19.5294 12.4428 20.0526 12.4428C20.5758 12.4428 21 12.8488 21 13.3495V18.2798C21 19.7821 19.7275 21 18.1579 21H5.84211C4.27245 21 3 19.7821 3 18.2798V13.3495C3 12.8488 3.42415 12.4428 3.94737 12.4428Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-disclosure-down": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.24408 9.23703C7.56951 8.92099 8.09715 8.92099 8.42259 9.23703L12 12.7111L15.5774 9.23703C15.9028 8.92099 16.4305 8.92099 16.7559 9.23703C17.0814 9.55306 17.0814 10.0655 16.7559 10.3815L12 15L7.24408 10.3815C6.91864 10.0655 6.91864 9.55306 7.24408 9.23703Z"
      fill="#6B7280"
    />
  ),
  "icon-plus": (
    <path
      d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H11V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H13V4Z"
      fill="#6B7280"
    />
  ),
  "icon-hamburger": (
    <>
      <path
        d="M3 5.14286C3 4.51167 3.50368 4 4.125 4H19.875C20.4963 4 21 4.51167 21 5.14286C21 5.77404 20.4963 6.28571 19.875 6.28571H4.125C3.50368 6.28571 3 5.77404 3 5.14286Z"
        fill="#6B7280"
      />
      <path
        d="M3 12C3 11.3688 3.50368 10.8571 4.125 10.8571H19.875C20.4963 10.8571 21 11.3688 21 12C21 12.6312 20.4963 13.1429 19.875 13.1429H4.125C3.50368 13.1429 3 12.6312 3 12Z"
        fill="#6B7280"
      />
      <path
        d="M4.125 17.7143C3.50368 17.7143 3 18.226 3 18.8571C3 19.4883 3.50368 20 4.125 20H19.875C20.4963 20 21 19.4883 21 18.8571C21 18.226 20.4963 17.7143 19.875 17.7143H4.125Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-profile": (
    <>
      <path d="M4 20V17C4 15.8954 4.89543 15 6 15H18C19.1046 15 20 15.8954 20 17V20" stroke="#6B7280" stroke-width="2" stroke-linecap="round" />
      <circle cx="12" cy="8" r="4" stroke="#6B7280" stroke-width="2" />
    </>
  ),
  "icon-logout": (
    <>
      <path d="M12 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H12" stroke="#6B7280" stroke-width="2" stroke-linecap="round" />
      <path d="M9 12H20" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M17 8L20.5 12L17 16" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </>
  ),
  "icon-globe": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 20C12.2151 20 12.9482 19.7737 13.7467 18.1766C14.0685 17.5329 14.3479 16.7556 14.5606 15.875H9.43938C9.65213 16.7556 9.93145 17.5329 10.2533 18.1766C11.0518 19.7737 11.7849 20 12 20ZM9.09772 13.875C9.03424 13.2766 9 12.6495 9 12C9 11.2594 9.04451 10.5479 9.12614 9.875H14.8739C14.9555 10.5479 15 11.2594 15 12C15 12.6495 14.9658 13.2766 14.9023 13.875H9.09772ZM16.6108 15.875C16.3442 17.142 15.951 18.2761 15.4627 19.2138C16.9595 18.494 18.1979 17.322 19.0006 15.875H16.6108ZM19.7791 13.875H16.9123C16.9699 13.2677 17 12.6409 17 12C17 11.2708 16.961 10.5598 16.8869 9.875H19.7147C19.9007 10.5517 20 11.2642 20 12C20 12.6457 19.9235 13.2736 19.7791 13.875ZM7.08775 13.875H4.22094C4.0765 13.2736 4 12.6457 4 12C4 11.2642 4.09932 10.5517 4.2853 9.875H7.11312C7.03902 10.5598 7 11.2708 7 12C7 12.6409 7.03014 13.2677 7.08775 13.875ZM4.99944 15.875H7.38925C7.65577 17.142 8.04904 18.2761 8.53731 19.2138C7.04045 18.494 5.80213 17.322 4.99944 15.875ZM9.50228 7.875H14.4977C14.294 7.09683 14.0377 6.40548 13.7467 5.82336C12.9482 4.22632 12.2151 4 12 4C11.7849 4 11.0518 4.22632 10.2533 5.82336C9.96226 6.40548 9.70599 7.09683 9.50228 7.875ZM16.5561 7.875H18.8559C18.0527 6.54298 16.8724 5.46406 15.4627 4.78617C15.9186 5.66179 16.2917 6.70863 16.5561 7.875ZM8.53731 4.78617C8.08138 5.66179 7.70828 6.70863 7.44386 7.875H5.14409C5.94725 6.54298 7.12763 5.46406 8.53731 4.78617Z"
      fill="#6B7280"
    />
  ),
  "icon-disclosure-up": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.24408 14.763C7.56951 15.079 8.09715 15.079 8.42259 14.763L12 11.2889L15.5774 14.763C15.9028 15.079 16.4305 15.079 16.7559 14.763C17.0814 14.4469 17.0814 13.9345 16.7559 13.6185L12 9L7.24408 13.6185C6.91864 13.9345 6.91864 14.4469 7.24408 14.763Z"
      fill="#6B7280"
    />
  ),
  "icon-setting-filled": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5363 2C10.0147 2 9.57151 2.36214 9.49412 2.85166L9.48177 2.9298C9.33527 3.85651 8.63181 4.60411 7.77744 5.07411C6.92286 5.54423 5.90194 5.73931 4.98267 5.39625L4.90333 5.36664C4.41785 5.18547 3.86575 5.36858 3.60491 5.79726L2.14126 8.20275C1.88043 8.63143 1.98936 9.17667 2.39745 9.48502L2.46302 9.53457C3.23586 10.1185 3.56891 11.0626 3.56891 12C3.56891 12.9374 3.23586 13.8815 2.46302 14.4654L2.39745 14.515C1.98936 14.8233 1.88043 15.3686 2.14126 15.7973L3.60491 18.2027C3.86575 18.6314 4.41785 18.8145 4.90333 18.6334L4.98268 18.6037C5.90194 18.2607 6.92287 18.4558 7.77744 18.9259C8.63181 19.3959 9.33527 20.1435 9.48177 21.0702L9.49412 21.1483C9.57151 21.6379 10.0147 22 10.5363 22H13.4636C13.9853 22 14.4285 21.6379 14.5059 21.1483L14.5182 21.0702C14.6647 20.1435 15.3682 19.3959 16.2226 18.9259C17.0771 18.4558 18.0981 18.2607 19.0173 18.6037L19.0967 18.6334C19.5821 18.8145 20.1343 18.6314 20.3951 18.2027L21.8587 15.7972C22.1196 15.3686 22.0106 14.8233 21.6026 14.515L21.537 14.4654C20.7641 13.8815 20.4311 12.9374 20.4311 12C20.4311 11.0626 20.7641 10.1185 21.537 9.53456L21.6026 9.48502C22.0106 9.17667 22.1196 8.63142 21.8587 8.20274L20.3951 5.79725C20.1343 5.36857 19.5821 5.18547 19.0967 5.36664L19.0173 5.39625C18.0981 5.7393 17.0771 5.54422 16.2226 5.07411C15.3682 4.60411 14.6647 3.85651 14.5182 2.9298L14.5059 2.85166C14.4285 2.36214 13.9853 2 13.4636 2H10.5363ZM12 15.75C14.1827 15.75 15.9521 14.0711 15.9521 12C15.9521 9.92893 14.1827 8.25 12 8.25C9.81731 8.25 8.04791 9.92893 8.04791 12C8.04791 14.0711 9.81731 15.75 12 15.75Z"
      fill="#6B7280"
    />
  ),
  "icon-setting-stroke": (
    <>
      <path
        d="M13.4636 2C13.9853 2 14.4285 2.36214 14.5059 2.85166L14.5182 2.9298C14.6647 3.85651 15.3682 4.60411 16.2226 5.07411C17.0771 5.54422 18.0981 5.7393 19.0173 5.39625L19.0967 5.36664C19.5821 5.18547 20.1343 5.36857 20.3951 5.79725L21.8587 8.20274C22.1196 8.63142 22.0106 9.17667 21.6025 9.48502L21.537 9.53456C20.7641 10.1185 20.4311 11.0626 20.4311 12C20.4311 12.9374 20.7641 13.8815 21.537 14.4654L21.6026 14.515C22.0106 14.8233 22.1196 15.3686 21.8587 15.7972L20.3951 18.2027C20.1343 18.6314 19.5821 18.8145 19.0967 18.6334L19.0173 18.6037C18.0981 18.2607 17.0771 18.4558 16.2226 18.9259C15.3682 19.3959 14.6647 20.1435 14.5182 21.0702L14.5059 21.1483C14.4285 21.6379 13.9853 22 13.4636 22H10.5363C10.0147 22 9.57151 21.6379 9.49412 21.1483L9.48177 21.0702C9.33527 20.1435 8.63181 19.3959 7.77744 18.9259L8.81964 17.2201C9.83294 17.7776 10.8845 18.7157 11.3471 20.0283H12.6529C13.1155 18.7157 14.1671 17.7776 15.1804 17.2201C16.2079 16.6549 17.5811 16.2723 19.0015 16.5497L19.6535 15.4781C18.6891 14.4467 18.3532 13.1213 18.3532 12C18.3532 10.8787 18.6891 9.55332 19.6535 8.52185L19.0015 7.45028C17.5811 7.72771 16.2079 7.3451 15.1804 6.77986C14.1671 6.22243 13.1155 5.28434 12.6529 3.97168H11.3471C10.8845 5.28434 9.83294 6.22243 8.81964 6.77986C7.79214 7.3451 6.41885 7.72771 4.99848 7.45029L4.34648 8.52185C5.31086 9.55332 5.64684 10.8787 5.64684 12C5.64684 13.1213 5.31086 14.4467 4.34648 15.4782L4.99848 16.5497C6.41885 16.2723 7.79214 16.6549 8.81964 17.2201L7.77744 18.9259C6.92287 18.4558 5.90194 18.2607 4.98268 18.6037L4.90333 18.6334C4.41785 18.8145 3.86575 18.6314 3.60491 18.2027L2.14126 15.7973C1.88043 15.3686 1.98936 14.8233 2.39745 14.515L2.46302 14.4654C3.23586 13.8815 3.56891 12.9374 3.56891 12C3.56891 11.0626 3.23586 10.1185 2.46302 9.53457L2.39745 9.48502C1.98936 9.17667 1.88043 8.63143 2.14126 8.20275L3.60491 5.79726C3.86575 5.36858 4.41785 5.18547 4.90333 5.36664L4.98267 5.39625C5.90194 5.73931 6.92286 5.54423 7.77744 5.07411C8.63181 4.60411 9.33527 3.85651 9.48177 2.9298L9.49412 2.85166C9.57151 2.36214 10.0147 2 10.5363 2H13.4636Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1558 12C16.1558 14.1779 14.2952 15.9434 12 15.94 34C9.70477 15.9434 7.84414 14.1779 7.84414 12C7.84414 9.82214 9.70477 8.05664 12 8.05664C14.2952 8.05664 16.1558 9.82214 16.1558 12ZM14.0779 12C14.0779 13.0889 13.1476 13.9717 12 13.9717C10.8524 13.9717 9.92206 13.0889 9.92206 12C9.92206 10.9111 10.8524 10.0283 12 10.0283C13.1476 10.0283 14.0779 10.9111 14.0779 12Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-filter": (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7229 8.66667C17.101 8.66667 18.2716 7.72249 18.693 6.40972L20.9543 6.40972C21.5318 6.40972 22 5.91226 22 5.29861C22 4.68496 21.5318 4.1875 20.9543 4.1875L18.6699 4.1875C18.2301 2.91101 17.0766 2 15.7229 2C14.369 2 13.2155 2.91115 12.7758 4.1878L12.7516 4.1875H3.04575C2.4682 4.1875 2 4.68496 2 5.29861C2 5.91226 2.4682 6.40972 3.04575 6.40972H12.7516L12.7528 6.40972C13.1741 7.72248 14.3447 8.66667 15.7229 8.66667ZM15.7229 6.44444C16.3004 6.44444 16.7686 5.94698 16.7686 5.33333C16.7686 4.71968 16.3004 4.22222 15.7229 4.22222C15.1453 4.22222 14.6771 4.71968 14.6771 5.33333C14.6771 5.94698 15.1453 6.44444 15.7229 6.44444Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 18.6319C2 18.0183 2.4682 17.5208 3.04575 17.5208H5.32753C5.7673 16.2443 6.92077 15.3333 8.27451 15.3333C9.62825 15.3333 10.7817 16.2443 11.2215 17.5208L20.9543 17.5208C21.5318 17.5208 22 18.0183 22 18.6319C22 19.2456 21.5318 19.7431 20.9543 19.7431H11.2446C10.8233 21.0558 9.65267 22 8.27451 22C6.89635 22 5.72574 21.0558 5.30442 19.7431H3.04575C2.4682 19.7431 2 19.2456 2 18.6319ZM9.32026 18.6667C9.32026 19.2803 8.85206 19.7778 8.27451 19.7778C7.69696 19.7778 7.22876 19.2803 7.22876 18.6667C7.22876 18.053 7.69696 17.5556 8.27451 17.5556C8.85206 17.5556 9.32026 18.053 9.32026 18.6667Z"
        fill="#6B7280"
      />
      <path
        d="M3.04575 10.8542C2.4682 10.8542 2 11.3516 2 11.9653C2 12.5789 2.4682 13.0764 3.04575 13.0764H20.9516C21.5292 13.0764 21.9974 12.5789 21.9974 11.9653C21.9974 11.3516 21.5292 10.8542 20.9516 10.8542H3.04575Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-credit-gradient": (
    <>
      <path d="M12 21C16.004 21 19 18 19 14C19 10.024 16.004 3 12 3C7.996 3 5 10.024 5 14C5 18 7.996 21 12 21Z" stroke="url(#paint0_linear_5103_17191)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M14.3635 14.364C13.944 14.7835 13.4094 15.0692 12.8275 15.185C12.2455 15.3008 11.6423 15.2413 11.0941 15.0143C10.546 14.7872 10.0774 14.4027 9.74778 13.9094C9.41813 13.416 9.24219 12.836 9.24219 12.2426C9.24219 11.6493 9.41813 11.0693 9.74778 10.5759C10.0774 10.0826 10.546 9.69807 11.0941 9.471C11.6423 9.24394 12.2455 9.18453 12.8275 9.30028C13.4094 9.41604 13.944 9.70176 14.3635 10.1213" stroke="url(#paint1_linear_5103_17191)" stroke-width="2" stroke-linecap="round" />
      <defs>
        <linearGradient id="paint0_linear_5103_17191" x1="5" y1="12" x2="19" y2="12" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A734F4" />
          <stop offset="0.875" stop-color="#640CE8" />
        </linearGradient>
        <linearGradient id="paint1_linear_5103_17191" x1="10.1209" y1="10.1213" x2="14.3635" y2="14.364" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A734F4" />
          <stop offset="0.875" stop-color="#640CE8" />
        </linearGradient>
      </defs>


    </>
  ),
  "icon-credit": (
    <>
      <path d="M12 21C16.004 21 19 18 19 14C19 10.024 16.004 3 12 3C7.996 3 5 10.024 5 14C5 18 7.996 21 12 21Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M14.364 14.364C13.9444 14.7835 13.4099 15.0692 12.8279 15.185C12.246 15.3008 11.6428 15.2413 11.0946 15.0143C10.5464 14.7872 10.0779 14.4027 9.74824 13.9094C9.41859 13.416 9.24265 12.836 9.24265 12.2426C9.24265 11.6493 9.41859 11.0693 9.74824 10.5759C10.0779 10.0826 10.5464 9.69807 11.0946 9.471C11.6428 9.24394 12.246 9.18453 12.8279 9.30028C13.4099 9.41604 13.9444 9.70176 14.364 10.1213" stroke="#6B7280" stroke-width="2" stroke-linecap="round" />
    </>
  ),
  "icon-pencil": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3528 3.28044C16.7267 2.90652 17.333 2.90652 17.7069 3.28045L20.7196 6.29311C21.0935 6.66704 21.0935 7.2733 20.7196 7.64722L7.66678 20.7C7.48873 20.878 7.24771 20.9788 6.99591 20.9804L3.96368 21C3.43005 21.0034 2.99658 20.57 3.00002 20.0363L3.01958 17.0041C3.02121 16.7523 3.12196 16.5113 3.30001 16.3332L16.3528 3.28044ZM16.0394 6.302L17.0298 5.31161L18.6884 6.97017L17.698 7.96056L16.0394 6.302ZM14.6853 7.65611L4.93201 17.4094L4.92124 19.0788L6.59057 19.068L16.3439 9.31467L14.6853 7.65611Z"
      fill="#6B7280"
    />
  ),
  "icon-gallery": (
    <>
      <path
        d="M17.9062 9.802C17.9062 10.9066 17.0108 11.802 15.9062 11.802C14.8017 11.802 13.9062 10.9066 13.9062 9.802C13.9062 8.69743 14.8017 7.802 15.9062 7.802C17.0108 7.802 17.9062 8.69743 17.9062 9.802Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4ZM20 6H4V11.864C5.10963 11.3007 6.65098 10.7542 8.56408 10.8771C10.138 10.9781 11.4489 11.6331 12.7355 12.276C13.044 12.4302 13.3512 12.5836 13.6602 12.7286C15.1794 13.4412 17.0602 14.148 20 14.32V6ZM20 16.3231C16.6888 16.1455 14.5289 15.3452 12.8108 14.5393C12.3922 14.3429 12.0166 14.1569 11.6698 13.9852C10.4387 13.3755 9.57104 12.9458 8.43591 12.8729C6.96972 12.7788 5.77748 13.1993 4.86696 13.6669C4.54019 13.8347 4.25497 14.0056 4 14.1643V18H20V16.3231Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-model": (
    <>
      <path
        d="M18.4233 12.4966C18.2518 12.7855 18.0801 13.0745 17.9325 13.3694C15.0554 12.7177 12.7605 10.6164 11.9286 7.91175C11.2285 10.6991 8.85048 12.8575 5.87942 13.3443C5.75973 13.0882 5.62776 12.8359 5.4961 12.5841C5.07396 11.7769 4.65508 10.9759 4.65508 10.0787C4.65508 6.16924 7.94193 3 11.9965 3C16.051 3 19.3379 6.16924 19.3379 10.0787C19.3379 10.9568 18.8809 11.7263 18.4233 12.4966Z"
        fill="#6B7280"
      />
      <path
        d="M14.0517 15.4877C14.3443 15.4877 14.5815 14.9874 14.5815 14.3702C14.5815 13.753 14.3443 13.2526 14.0517 13.2526C13.7591 13.2526 13.5219 13.753 13.5219 14.3702C13.5219 14.9874 13.7591 15.4877 14.0517 15.4877Z"
        fill="#6B7280"
      />
      <path
        d="M10.3733 14.3702C10.3733 14.9874 10.1361 15.4877 9.84345 15.4877C9.55084 15.4877 9.31364 14.9874 9.31364 14.3702C9.31364 13.753 9.55084 13.2526 9.84345 13.2526C10.1361 13.2526 10.3733 13.753 10.3733 14.3702Z"
        fill="#6B7280"
      />
      <path
        d="M5.28651 15.6489C5.53893 15.4302 5.81667 15.2565 6.10861 15.1197C6.91718 16.7744 8.40322 18.0894 9.91532 18.7486C9.6752 19.2778 9.3473 19.7716 8.90038 20.1588C6.99289 21.8113 4.45685 20.5573 4.2822 20.3394C4.10755 20.1214 3.37902 17.3014 5.28651 15.6489Z"
        fill="#6B7280"
      />
      <path
        d="M15.0996 20.1588C14.6372 19.7582 14.3022 19.2434 14.06 18.6934C15.5457 18.01 16.989 16.7003 17.7698 15.0651C18.1062 15.2094 18.4262 15.4 18.7135 15.6489C20.621 17.3014 19.8925 20.1214 19.7178 20.3394C19.5432 20.5573 17.0071 21.8113 15.0996 20.1588Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-home-filled": (
    <path
      d="M4.24377 6.24007C3.48151 6.60903 3 7.36324 3 8.18826V18.8219C3 20.0248 4.00736 21 5.25 21L8.625 21C9.24632 21 9.75 20.5124 9.75 19.9109V13.3765C9.75 12.775 10.2537 12.2874 10.875 12.2874H13.125C13.7463 12.2874 14.25 12.775 14.25 13.3765V19.9109C14.25 20.5124 14.7537 21 15.375 21L18.75 21C19.9926 21 21 20.0248 21 18.8219V8.18826C21 7.36324 20.5185 6.60903 19.7562 6.24007L14.0125 3.4599C12.7456 2.8467 11.2544 2.8467 9.98754 3.4599L4.24377 6.24007Z"
      fill="#6B7280"
    />
  ),
  "icon-home-stroke": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 8.18826V18.8219L8.625 18.8219V13.3765C8.625 11.5721 10.136 10.1093 12 10.1093C13.864 10.1093 15.375 11.5721 15.375 13.3765V18.8219L18.75 18.8219L18.75 8.18826L13.0062 5.40809C12.3728 5.10149 11.6272 5.10149 10.9938 5.40809L5.25 8.18826ZM3 8.18826C3 7.36324 3.48151 6.60903 4.24377 6.24007L9.98754 3.4599C11.2544 2.8467 12.7456 2.8467 14.0125 3.4599L19.7562 6.24007C20.5185 6.60903 21 7.36324 21 8.18826V18.8219C21 20.0248 19.9926 21 18.75 21L14.25 21C13.6287 21 13.125 20.5124 13.125 19.9109V13.3765C13.125 12.775 12.6213 12.2874 12 12.2874C11.3787 12.2874 10.875 12.775 10.875 13.3765V19.9109C10.875 20.5124 10.3713 21 9.75 21L5.25 21C4.00736 21 3 20.0248 3 18.8219V8.18826Z"
      fill="#6B7280"
    />
  ),
  "icon-pile": (
    <>
      <path
        d="M3 3.9914C3 3.44386 3.44386 3 3.9914 3H10.1086C10.6561 3 11.1 3.44386 11.1 3.9914V10.1086C11.1 10.6561 10.6561 11.1 10.1086 11.1H3.9914C3.44386 11.1 3 10.6561 3 10.1086V3.9914Z"
        fill="#6B7280"
      />
      <path
        d="M3 13.8914C3 13.3439 3.44386 12.9 3.9914 12.9H10.1086C10.6561 12.9 11.1 13.3439 11.1 13.8914V20.0086C11.1 20.5561 10.6561 21 10.1086 21H3.9914C3.44386 21 3 20.5561 3 20.0086V13.8914Z"
        fill="#6B7280"
      />
      <path
        d="M12.9 3.9914C12.9 3.44386 13.3439 3 13.8914 3H20.0086C20.5561 3 21 3.44386 21 3.9914V10.1086C21 10.6561 20.5561 11.1 20.0086 11.1H13.8914C13.3439 11.1 12.9 10.6561 12.9 10.1086V3.9914Z"
        fill="#6B7280"
      />
      <path
        d="M12.9 13.8914C12.9 13.3439 13.3439 12.9 13.8914 12.9H20.0086C20.5561 12.9 21 13.3439 21 13.8914V20.0086C21 20.5561 20.5561 21 20.0086 21H13.8914C13.3439 21 12.9 20.5561 12.9 20.0086V13.8914Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-camera": (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4 12.5481C16.4 14.9782 14.4301 16.9481 12 16.9481C9.56995 16.9481 7.6 14.9782 7.6 12.5481C7.6 10.1181 9.56995 8.14815 12 8.14815C14.4301 8.14815 16.4 10.1181 16.4 12.5481ZM14.5037 12.5481C14.5037 13.9309 13.3828 15.0518 12 15.0518C10.6172 15.0518 9.4963 13.9309 9.4963 12.5481C9.4963 11.1654 10.6172 10.0444 12 10.0444C13.3828 10.0444 14.5037 11.1654 14.5037 12.5481Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.51957 4C8.90423 4 8.32715 4.29858 7.97168 4.80086L7.12306 6H4.8963C3.849 6 3 6.849 3 7.8963V18.1037C3 19.151 3.849 20 4.8963 20H19.1037C20.151 20 21 19.151 21 18.1037V7.8963C21 6.849 20.151 6 19.1037 6H16.8769L16.0283 4.80086C15.6728 4.29858 15.0957 4 14.4804 4H9.51957ZM4.8963 7.8963H8.10419L9.51957 5.8963L14.4804 5.8963L15.8958 7.8963H19.1037V18.1037H4.8963L4.8963 7.8963Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-modelcut": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM12 8.5C13.1046 8.5 14 7.60457 14 6.5C14 5.39543 13.1046 4.5 12 4.5C10.8954 4.5 10 5.39543 10 6.5C10 7.60457 10.8954 8.5 12 8.5ZM9.5 11.505C9.5 10.1243 10.6193 9.005 12 9.005C13.3807 9.005 14.5 10.1243 14.5 11.505V13.1717C14.5 14.3223 13.5673 15.255 12.4167 15.255H11.5833C10.4327 15.255 9.5 14.3223 9.5 13.1717V11.505ZM12 15.7599C11.4477 15.7599 11 16.2076 11 16.7599V18.5724C11 19.1247 11.4477 19.5724 12 19.5724C12.5523 19.5724 13 19.1247 13 18.5724V16.7599C13 16.2076 12.5523 15.7599 12 15.7599Z"
      fill="#6B7280"
    />
  ),
  "icon-clothes_box": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5ZM12.0001 7.80391C12.6597 7.80391 12.9894 7.51769 13.3192 6.94526C13.649 6.37283 13.9787 6.33826 14.6382 6.33826C15.6408 6.33826 17.6489 7.56658 18.8524 8.47467C18.9613 8.55684 18.9975 8.70231 18.9439 8.82687C18.5403 9.76466 17.9845 10.6398 17.3034 11.4051C17.2322 11.4851 17.1234 11.5191 17.016 11.5097C16.219 11.4401 15.8972 12.0545 15.8972 12.4502V16.6644C15.8972 17.0189 15.6285 17.3101 15.2813 17.3525C15.2701 17.3538 15.2588 17.3551 15.2476 17.3564C15.201 17.3619 15.1543 17.3673 15.1084 17.3773C14.8003 17.4444 13.6737 17.6616 12 17.6618C10.3264 17.6616 9.1998 17.4444 8.89166 17.3773C8.8458 17.3673 8.79913 17.3619 8.75248 17.3564C8.74126 17.3551 8.73004 17.3538 8.71884 17.3525C8.37162 17.3101 8.10289 17.0189 8.10289 16.6644V12.4502C8.10289 12.0545 7.78109 11.4401 6.98404 11.5097C6.87668 11.5191 6.76787 11.4851 6.69672 11.4051C6.01561 10.6398 5.45976 9.76466 5.05621 8.82687C5.00261 8.70231 5.03881 8.55684 5.1477 8.47467C6.3512 7.56658 8.35926 6.33826 9.36184 6.33826C10.0214 6.33826 10.3511 6.37283 10.6809 6.94526C11.0107 7.51769 11.3406 7.80391 12.0001 7.80391Z"
      fill="#6B7280"
    />
  ),
  "icon-support-stroke-circled": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 19.8571C14.0838 19.8571 16.0823 19.0293 17.5558 17.5558C19.0293 16.0823 19.8571 14.0838 19.8571 12C19.8571 9.91616 19.0293 7.91766 17.5558 6.44416C16.0823 4.97066 14.0838 4.14286 12 4.14286C9.91616 4.14286 7.91766 4.97066 6.44416 6.44416C4.97066 7.91766 4.14286 9.91616 4.14286 12C4.14286 14.0838 4.97066 16.0823 6.44416 17.5558C7.91766 19.0293 9.91616 19.8571 12 19.8571ZM12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22ZM9.77143 7.05714C10.3857 6.55143 11.1914 6.25 12 6.25C13.7386 6.25 15.3429 7.42143 15.3429 9.30714C15.3429 9.84571 15.23 10.3714 14.9171 10.8786C14.62 11.3629 14.1843 11.7557 13.6671 12.1171C13.3571 12.3357 13.2014 12.4843 13.1257 12.5857C13.0714 12.66 13.0714 12.6857 13.0714 12.7129C13.0714 12.997 12.9585 13.2695 12.7576 13.4705C12.5567 13.6714 12.2842 13.7843 12 13.7843C11.7158 13.7843 11.4433 13.6714 11.2424 13.4705C11.0415 13.2695 10.9286 12.997 10.9286 12.7129C10.9286 11.5786 11.7057 10.8757 12.4386 10.3629C12.8386 10.0829 13.01 9.88857 13.0929 9.75429C13.1722 9.61974 13.209 9.4644 13.1986 9.30857C13.1986 8.88 12.8514 8.39286 12 8.39286C11.6831 8.39944 11.3774 8.51155 11.1314 8.71143C10.8929 8.90857 10.8014 9.12143 10.8014 9.30857C10.8014 9.59273 10.6885 9.86525 10.4876 10.0662C10.2867 10.2671 10.0142 10.38 9.73 10.38C9.44584 10.38 9.17332 10.2671 8.97239 10.0662C8.77145 9.86525 8.65857 9.59273 8.65857 9.30857C8.65857 8.34571 9.15143 7.56571 9.77286 7.05571L9.77143 7.05714ZM12 17.7143C12.3789 17.7143 12.7422 17.5638 13.0102 17.2959C13.2781 17.028 13.4286 16.6646 13.4286 16.2857C13.4286 15.9068 13.2781 15.5435 13.0102 15.2756C12.7422 15.0077 12.3789 14.8571 12 14.8571C11.6211 14.8571 11.2578 15.0077 10.9898 15.2756C10.7219 15.5435 10.5714 15.9068 10.5714 16.2857C10.5714 16.6646 10.7219 17.028 10.9898 17.2959C11.2578 17.5638 11.6211 17.7143 12 17.7143Z"
      fill="#6B7280"
    />
  ),
  "icon-support-filled-circled": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22ZM9.77143 7.05714C10.3857 6.55143 11.1914 6.25 12 6.25C13.7386 6.25 15.3429 7.42143 15.3429 9.30714C15.3429 9.84571 15.23 10.3714 14.9171 10.8786C14.62 11.3629 14.1843 11.7557 13.6671 12.1171C13.3571 12.3357 13.2014 12.4843 13.1257 12.5857C13.0714 12.66 13.0714 12.6857 13.0714 12.7129C13.0714 12.997 12.9585 13.2695 12.7576 13.4705C12.5567 13.6714 12.2842 13.7843 12 13.7843C11.7158 13.7843 11.4433 13.6714 11.2424 13.4705C11.0415 13.2695 10.9286 12.997 10.9286 12.7129C10.9286 11.5786 11.7057 10.8757 12.4371 10.3629C12.8371 10.0829 13.0114 9.88857 13.0943 9.75571C13.1734 9.6206 13.2097 9.46473 13.1986 9.30857C13.1986 8.88 12.8514 8.39286 12 8.39286C11.6829 8.39984 11.3772 8.51246 11.1314 8.71286C10.8929 8.90857 10.8014 9.12143 10.8014 9.30857C10.8014 9.59273 10.6885 9.86525 10.4876 10.0662C10.2867 10.2671 10.0142 10.38 9.73 10.38C9.44584 10.38 9.17332 10.2671 8.97239 10.0662C8.77145 9.86525 8.65857 9.59273 8.65857 9.30857C8.65857 8.34714 9.15143 7.56571 9.77286 7.05571L9.77143 7.05714ZM13.4286 16.2857C13.4286 16.6646 13.2781 17.028 13.0102 17.2959C12.7422 17.5638 12.3789 17.7143 12 17.7143C11.6211 17.7143 11.2578 17.5638 10.9898 17.2959C10.7219 17.028 10.5714 16.6646 10.5714 16.2857C10.5714 15.9068 10.7219 15.5435 10.9898 15.2756C11.2578 15.0077 11.6211 14.8571 12 14.8571C12.3789 14.8571 12.7422 15.0077 13.0102 15.2756C13.2781 15.5435 13.4286 15.9068 13.4286 16.2857Z"
      fill="#6B7280"
    />
  ),
  "icon-redo": (
    <path
      d="M17.811 6.22682C17.6327 5.92105 17.1722 5.9253 17.0001 6.2343L15.9509 8.11734C14.7563 7.55521 13.4125 7.23946 11.9931 7.23946C7.02633 7.23946 3 11.0993 3 15.8606C3 17.1541 3.29777 18.3834 3.83206 19.4868C4.04698 19.9307 4.59654 20.1235 5.05953 19.9174C5.52253 19.7114 5.72363 19.1846 5.50871 18.7407C5.08529 17.8663 4.84849 16.8912 4.84849 15.8606C4.84849 12.078 8.04722 9.0115 11.9931 9.0115C13.0993 9.0115 14.1456 9.252 15.0794 9.68153L13.9213 11.7601C13.7543 12.0599 13.987 12.4208 14.3413 12.4117L20.5497 12.252C20.897 12.2431 21.1102 11.8837 20.9406 11.593L17.811 6.22682Z"
      fill="#6B7280"
    />
  ),
  "icon-undo": (
    <path
      d="M6.18895 6.22682C6.36728 5.92105 6.82777 5.9253 6.99993 6.2343L8.04908 8.11734C9.24375 7.55521 10.5875 7.23946 12.0069 7.23946C16.9737 7.23946 21 11.0993 21 15.8606C21 17.1541 20.7022 18.3834 20.1679 19.4868C19.953 19.9307 19.4035 20.1235 18.9405 19.9174C18.4775 19.7114 18.2764 19.1846 18.4913 18.7407C18.9147 17.8663 19.1515 16.8912 19.1515 15.8606C19.1515 12.078 15.9528 9.0115 12.0069 9.0115C10.9007 9.0115 9.85443 9.252 8.92059 9.68153L10.0787 11.7601C10.2457 12.0599 10.013 12.4208 9.65868 12.4117L3.45034 12.252C3.10302 12.2431 2.88982 11.8837 3.05938 11.593L6.18895 6.22682Z"
      fill="#6B7280"
    />
  ),
  "icon-flip": (
    <>
      <g id="icon-flip" transform="translate(-1.5, -1.5) scale(1.425)">
        <path id="Vector 16" d="M9 3V15" stroke="#1F2937" stroke-width="1.5" stroke-linecap="round" />
        <path id="Vector 17" d="M6.75 4.5H5C3.89543 4.5 3 5.39543 3 6.5V11.5C3 12.6046 3.89543 13.5 5 13.5H6.75" stroke="#1F2937" stroke-width="1.5" stroke-linecap="round" />
        <path id="Vector 18" d="M11.25 4.5H13C14.1046 4.5 15 5.39543 15 6.5V11.5C15 12.6046 14.1046 13.5 13 13.5H11.25" stroke="#1F2937" stroke-width="1.5" stroke-linecap="round" />
      </g>
    </>
  ),
  "icon-copy": (
    <>
      <rect
        x="4"
        y="9"
        width="12"
        height="12"
        rx="2"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16 15H18C19.1046 15 20 14.1046 20 13V5C20 3.89543 19.1046 3 18 3H10C8.89543 3 8 3.89543 8 5V9"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </>
  ),
  "icon-save-stroke": (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18.875C13.8985 18.875 15.4375 17.336 15.4375 15.4375C15.4375 13.539 13.8985 12 12 12C10.1015 12 8.5625 13.539 8.5625 15.4375C8.5625 17.336 10.1015 18.875 12 18.875ZM12 16.875C12.7939 16.875 13.4375 16.2314 13.4375 15.4375C13.4375 14.6436 12.7939 14 12 14C11.2061 14 10.5625 14.6436 10.5625 15.4375C10.5625 16.2314 11.2061 16.875 12 16.875Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.08475 6.125C6.08475 5.57272 6.53246 5.125 7.08475 5.125H15.625C16.1773 5.125 16.625 5.57272 16.625 6.125V9.75C16.625 10.3023 16.1773 10.75 15.625 10.75H7.08475C6.53246 10.75 6.08475 10.3023 6.08475 9.75V6.125ZM8.08475 8.75V7.125H14.625V8.75H8.08475Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5C3 3.34315 4.34315 2 6 2H16.1716C16.9672 2 17.7303 2.31607 18.2929 2.87868L20.1213 4.70711C20.6839 5.26972 21 6.03278 21 6.82843V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5ZM6 4C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V6.82843C19 6.56321 18.8946 6.30886 18.7071 6.12132L16.8787 4.29289C16.6911 4.10536 16.4368 4 16.1716 4H6Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-save-fill": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V6.82843C21 6.03278 20.6839 5.26972 20.1213 4.70711L18.2929 2.87868C17.7303 2.31607 16.9672 2 16.1716 2H6ZM14.8594 16.0781C14.8594 17.6573 13.5792 18.9375 12 18.9375C10.4208 18.9375 9.14062 17.6573 9.14062 16.0781C9.14062 14.4989 10.4208 13.2188 12 13.2188C13.5792 13.2188 14.8594 14.4989 14.8594 16.0781ZM6.741 5.125C6.18871 5.125 5.741 5.57272 5.741 6.125V9.75C5.741 10.3023 6.18871 10.75 6.741 10.75H15.2812C15.8335 10.75 16.2812 10.3023 16.2812 9.75V6.125C16.2812 5.57272 15.8335 5.125 15.2812 5.125H6.741Z"
      fill="#6B7280"
    />
  ),
  "icon-double_arrow_left": (
    <>
      <path
        d="M13.2577 4.55728C13.6223 4.20103 13.6223 3.62344 13.2577 3.26719C12.8931 2.91094 12.302 2.91094 11.9374 3.26719L3 12L11.9374 20.7328C12.302 21.0891 12.8931 21.0891 13.2577 20.7328C13.6223 20.3766 13.6223 19.799 13.2577 19.4427L5.64064 12L13.2577 4.55728Z"
        fill="#6B7280"
      />
      <path
        d="M20.7266 4.55728C21.0911 4.20103 21.0911 3.62344 20.7266 3.26719C20.362 2.91094 19.7708 2.91094 19.4062 3.26719L10.4688 12L19.4062 20.7328C19.7708 21.0891 20.362 21.0891 20.7266 20.7328C21.0911 20.3766 21.0911 19.799 20.7266 19.4427L13.1095 12L20.7266 4.55728Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-double_arrow_right": (
    <>
      <path
        d="M3.27345 4.55728C2.90885 4.20103 2.90885 3.62344 3.27345 3.26719C3.63804 2.91094 4.22917 2.91094 4.59376 3.26719L13.5312 12L4.59376 20.7328C4.22917 21.0891 3.63804 21.0891 3.27345 20.7328C2.90885 20.3766 2.90885 19.799 3.27345 19.4427L10.8905 12L3.27345 4.55728Z"
        fill="#6B7280"
      />
      <path
        d="M10.7423 4.55728C10.3777 4.20103 10.3777 3.62344 10.7423 3.26719C11.1069 2.91094 11.698 2.91094 12.0626 3.26719L21 12L12.0626 20.7328C11.698 21.0891 11.1069 21.0891 10.7423 20.7328C10.3777 20.3766 10.3777 19.799 10.7423 19.4427L18.3594 12L10.7423 4.55728Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-violet_arrow_right_40": (
    <>
      <path d="M2.33337 13C1.2288 13 0.333374 13.8954 0.333374 15C0.333374 16.1046 1.2288 17 2.33337 17V13ZM43.7476 16.4142C44.5286 15.6332 44.5286 14.3668 43.7476 13.5858L31.0197 0.857864C30.2386 0.0768156 28.9723 0.0768156 28.1912 0.857864C27.4102 1.63891 27.4102 2.90524 28.1912 3.68629L39.5049 15L28.1912 26.3137C27.4102 27.0948 27.4102 28.3611 28.1912 29.1421C28.9723 29.9232 30.2386 29.9232 31.0197 29.1421L43.7476 16.4142ZM2.33337 15V17H42.3334V15V13H2.33337V15Z" fill="#640CE8" />
    </>
  ),
  "icon-violet_arrow_right_20": (
    <>
      <path d="M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V7ZM17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289L11.3431 0.928932C10.9526 0.538408 10.3195 0.538408 9.92893 0.928932C9.53841 1.31946 9.53841 1.95262 9.92893 2.34315L15.5858 8L9.92893 13.6569C9.53841 14.0474 9.53841 14.6805 9.92893 15.0711C10.3195 15.4616 10.9526 15.4616 11.3431 15.0711L17.7071 8.70711ZM1 8V9H17V8V7H1V8Z" fill="#640CE8" />
    </>
  ),
  "icon-clothes_top": (
    <path
      d="M13.8931 4.85769C13.4198 5.66653 12.9466 6.07095 12.0001 6.07095C11.0537 6.07095 10.5802 5.66653 10.1069 4.85769C9.6337 4.04886 9.16047 4 8.214 4C6.77522 4 3.89352 5.73561 2.16642 7.01874C2.01015 7.13483 1.95819 7.34039 2.03511 7.51639C2.61424 8.84147 3.41193 10.078 4.38936 11.1594C4.49148 11.2724 4.64762 11.3204 4.80169 11.3072C5.94551 11.2089 6.40731 12.077 6.40731 12.6361V18.5908C6.40731 19.0917 6.79296 19.5031 7.29124 19.563C7.37421 19.5729 7.45761 19.5805 7.53925 19.598C7.98145 19.6929 9.59826 19.9998 12 20C14.4017 19.9998 16.0185 19.6929 16.4608 19.598C16.5424 19.5805 16.6258 19.5729 16.7088 19.563C17.207 19.5031 17.5927 19.0917 17.5927 18.5908V12.6361C17.5927 12.077 18.0545 11.2089 19.1983 11.3072C19.3524 11.3204 19.5085 11.2724 19.6106 11.1594C20.5881 10.078 21.3858 8.84147 21.9649 7.51639C22.0418 7.34039 21.9898 7.13483 21.8336 7.01874C20.1065 5.73561 17.2248 4 15.786 4C14.8395 4 14.3663 4.04886 13.8931 4.85769Z"
      fill="#6B7280"
    />
  ),
  "icon-clothes_pants": (
    <>
      <path
        d="M5.90644 4.5C5.77556 4.5 5.67986 4.37591 5.72894 4.25458C6.031 3.50794 6.76583 3 7.60139 3H16.3822C17.2186 3 17.9529 3.50879 18.2547 4.2546C18.3037 4.37592 18.208 4.5 18.0772 4.5H5.90644Z"
        fill="#6B7280"
      />
      <path
        d="M5.60426 5.5C5.50921 5.5 5.42729 5.5669 5.40829 5.66003L4.21701 11.5L3.00719 19.456C2.95975 19.768 3.15131 20.067 3.45634 20.157L4.94019 20.5952C5.84939 20.8636 6.79306 21 7.74173 21H9.00806C9.41167 21 9.76166 20.7234 9.85154 20.3333L11.7201 12.2242C11.7503 12.093 11.868 12 12.0038 12C12.1395 12 12.2572 12.093 12.2875 12.2242L14.156 20.3333C14.2459 20.7234 14.5959 21 14.9995 21H16.2658C17.2145 21 18.1582 20.8636 19.0674 20.5952L20.5447 20.159C20.8524 20.0681 21.0438 19.7646 20.9914 19.4506L19.6644 11.5L18.5603 5.66283C18.5425 5.56838 18.4599 5.5 18.3638 5.5H12.5082V7.5C12.5082 7.77614 12.2824 8 12.0038 8C11.7252 8 11.4994 7.77614 11.4994 7.5V5.5H5.60426Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-clothes_skirt": (
    <>
      <path
        d="M4.8928 5.02372C4.8928 4.45833 5.34737 4 5.90811 4H18.0918C18.6526 4 19.1072 4.45833 19.1072 5.02372V6.04743C19.1096 6.06432 19.0965 6.07943 19.0794 6.07943H4.88829L4.8928 6.04759V5.02372Z"
        fill="#6B7280"
      />
      <path
        d="M5.09057 7.10314C4.89133 7.10314 4.72247 7.24976 4.69452 7.44703L3.01035 19.3339C2.92929 19.906 3.33367 20.4323 3.90333 20.4961L4.82417 20.5993C6.0387 20.7353 7.25608 20.8368 8.47486 20.9035L8.83624 13.0927C8.84931 12.8103 9.08694 12.592 9.367 12.6052C9.64707 12.6184 9.86351 12.858 9.85045 13.1404L9.48908 20.9511C11.123 21.0148 12.7587 21.0163 14.3927 20.9556L14.0311 13.1404C14.0181 12.858 14.2345 12.6184 14.5146 12.6052C14.7947 12.592 15.0323 12.8103 15.0453 13.0927L15.407 20.9099C16.6653 20.8433 17.9221 20.7397 19.1758 20.5993L20.0967 20.4961C20.6663 20.4323 21.0707 19.906 20.9897 19.3339L19.3055 7.44703C19.2775 7.24976 19.1087 7.10314 18.9094 7.10314H5.09057Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-clothes_bottom": (
    <>
      <path
        d="M5.99123 18.335C5.8392 18.488 5.74068 18.686 5.71036 18.8994L5.61395 19.5783C5.54462 20.0665 5.89048 20.5156 6.37769 20.57L7.16526 20.6581C8.20401 20.7742 9.24521 20.8607 10.2876 20.9177L10.5967 15.1887C10.6079 14.9477 10.8111 14.7615 11.0506 14.7727C11.2902 14.784 11.4753 14.9884 11.4641 15.2294L11.155 20.9582C12.5525 21.0126 13.9515 21.0139 15.349 20.9621L15.0397 14.2935C15.0286 14.0525 15.2137 13.8481 15.4532 13.8368C15.6927 13.8256 15.896 14.0118 15.9072 14.2528L16.2165 20.9231C17.2926 20.8663 18.3675 20.7779 19.4398 20.6581L20.2274 20.57C20.7146 20.5156 21.0605 20.0665 20.9912 19.5783L19.509 9.14198H15.546C15.2797 9.14198 15.0245 9.24815 14.8368 9.43697L5.99123 18.335Z"
        fill="#6B7280"
      />
      <path
        d="M16.3374 7.92745C16.2119 8.05361 16.3013 8.26845 16.4792 8.26845H19.385L19.3811 8.24115V7.36763C19.3811 6.88519 18.9923 6.4941 18.5127 6.4941H18.1782C17.9119 6.4941 17.6567 6.60027 17.469 6.78909L16.3374 7.92745Z"
        fill="#6B7280"
      />
      <path
        d="M16.5192 5.99748L16.3675 5.18381H11.1845V6.93087C11.1845 7.17208 10.9901 7.36763 10.7503 7.36763C10.5105 7.36763 10.3161 7.17208 10.3161 6.93087V5.18381H5.10112L4.04758 10.425L3.00619 17.3748C2.96535 17.6473 3.13024 17.9084 3.39281 17.9871L3.74935 18.094C4.10265 18.1998 4.48555 18.1026 4.74558 17.841L9.99136 12.5641C10.137 12.4176 10.2336 12.2297 10.2681 12.026L10.5061 10.6208C10.5321 10.5062 10.6334 10.425 10.7503 10.425C10.8671 10.425 10.9685 10.5062 10.9945 10.6208C11.0314 10.9589 11.4436 11.1032 11.6834 10.862L16.5192 5.99748Z"
        fill="#6B7280"
      />
      <path
        d="M6.96079 3C6.16524 3 5.47577 3.54286 5.27918 4.31029H16.2008C16.0045 3.5439 15.3157 3 14.5191 3H6.96079Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-link": (
    <>
      <path
        d="M16 4H19.5C19.7761 4 20 4.22386 20 4.5V8"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M19 5L13 11" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M12 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </>
  ),
  "icon-caution-stroke-circled": (
    <>
      <path
        d="M12 6C12.5523 6 13 6.44772 13 7V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V7C11 6.44772 11.4477 6 12 6Z"
        fill="#6B7280"
      />
      <path
        d="M12 18.0938C12.6645 18.0938 13.2031 17.5551 13.2031 16.8906C13.2031 16.2262 12.6645 15.6875 12 15.6875C11.3355 15.6875 10.7969 16.2262 10.7969 16.8906C10.7969 17.5551 11.3355 18.0938 12 18.0938Z"
        fill="#6B7280"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        fill="#6B7280"
      />
    </>
  ),
  "icon-caution-stroke-circled-gradient": (
    <>
      <path
        d="M12 6C12.5523 6 13 6.44772 13 7V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V7C11 6.44772 11.4477 6 12 6Z"
        fill="url(#paint0_linear_caution)"
      />
      <path
        d="M12 18.0938C12.6645 18.0938 13.2031 17.5551 13.2031 16.8906C13.2031 16.2262 12.6645 15.6875 12 15.6875C11.3355 15.6875 10.7969 16.2262 10.7969 16.8906C10.7969 17.5551 11.3355 18.0938 12 18.0938Z"
        fill="url(#paint1_linear_caution)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        fill="url(#paint2_linear_caution)"
      />
      <defs>
        <linearGradient id="paint0_linear_caution" x1="11" y1="6" x2="13" y2="15" gradientUnits="userSpaceOnUse">
          <stop stopColor="#A734F4" />
          <stop offset="0.875" stopColor="#640CE8" />
        </linearGradient>
        <linearGradient id="paint1_linear_caution" x1="10.7969" y1="15.6875" x2="13.2031" y2="18.0938" gradientUnits="userSpaceOnUse">
          <stop stopColor="#A734F4" />
          <stop offset="0.875" stopColor="#640CE8" />
        </linearGradient>
        <linearGradient id="paint2_linear_caution" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop stopColor="#A734F4" />
          <stop offset="0.875" stopColor="#640CE8" />
        </linearGradient>
      </defs>
    </>
  ),
  "icon-caution-filled-circled": (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 5.45312C12.5523 5.45312 13 5.90084 13 6.45312V13.4531C13 14.0054 12.5523 14.4531 12 14.4531C11.4477 14.4531 11 14.0054 11 13.4531V6.45312C11 5.90084 11.4477 5.45312 12 5.45312ZM12 18.5469C12.6645 18.5469 13.2031 18.0082 13.2031 17.3438C13.2031 16.6793 12.6645 16.1406 12 16.1406C11.3355 16.1406 10.7969 16.6793 10.7969 17.3438C10.7969 18.0082 11.3355 18.5469 12 18.5469Z"
      fill="#6B7280"
    />
  ),
  "icon-add-stroke-circled-gradient": (
    <>
      <path d="M12 7V17" stroke="url(#paint0_linear_5426_4590)" stroke-width="2" stroke-linecap="round" />
      <path d="M7 12H17" stroke="url(#paint1_linear_5426_4590)" stroke-width="2" stroke-linecap="round" />
      <circle cx="12" cy="12" r="9" stroke="url(#paint2_linear_5426_4590)" stroke-width="2" />
      <defs>
        <linearGradient id="paint0_linear_5426_4590" x1="12" y1="12" x2="13" y2="12" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A734F4" />
          <stop offset="0.875" stop-color="#640CE8" />
        </linearGradient>
        <linearGradient id="paint1_linear_5426_4590" x1="7" y1="12.5" x2="17" y2="12.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A734F4" />
          <stop offset="0.875" stop-color="#640CE8" />
        </linearGradient>
        <linearGradient id="paint2_linear_5426_4590" x1="3" y1="12" x2="21" y2="12" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A734F4" />
          <stop offset="0.875" stop-color="#640CE8" />
        </linearGradient>
      </defs>
    </>
  ),
  "icon-add-stroke-circled": (
    <>
      <path d="M12 7V17" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />
      <path d="M7 12H17" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="12" r="9" stroke="#6B7280" strokeWidth="2" />
    </>
  ),
  "icon-card": (
    <>
      <rect
        x="3"
        y="5"
        width="18"
        height="14"
        rx="2"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <line x1="3" y1="10" x2="21" y2="10" stroke="#6B7280" strokeWidth="2" />
      <line x1="6" y1="15" x2="8" y2="15" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />
      <line
        x1="11"
        y1="15"
        x2="12"
        y2="15"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </>
  ),
  "icon-lightning": (
    <path
      d="M16.1375 2.08555C16.262 2.15647 16.3584 2.26677 16.4109 2.39845C16.4634 2.53013 16.4688 2.67539 16.4264 2.81051L14.1343 10.1251H18.3634C18.4877 10.125 18.6093 10.1607 18.7131 10.2278C18.817 10.2948 18.8986 10.3902 18.9479 10.5023C18.9971 10.6144 19.0119 10.7381 18.9904 10.8584C18.9688 10.9786 18.9119 11.09 18.8267 11.1788L8.64521 21.8032C8.5467 21.9061 8.41561 21.9731 8.2733 21.9935C8.131 22.0138 7.98587 21.9862 7.86158 21.9152C7.7373 21.8442 7.64117 21.7339 7.58888 21.6023C7.53658 21.4707 7.5312 21.3257 7.57361 21.1907L9.86571 13.8749H5.63659C5.51231 13.8749 5.39073 13.8392 5.28687 13.7722C5.18301 13.7052 5.1014 13.6097 5.05213 13.4977C5.00287 13.3856 4.98809 13.2618 5.00963 13.1416C5.03117 13.0214 5.08808 12.91 5.17334 12.8212L15.3548 2.19679C15.4532 2.09405 15.5841 2.02701 15.7262 2.00659C15.8683 1.98616 16.0132 2.01355 16.1375 2.0843V2.08555Z"
      fill="#6B7280"
    />
  ),
  "icon-send": (
    <path
      d="M2.6118 9.15652C1.78983 9.46946 1.65329 10.5798 2.38578 10.9882L7.74165 13.9682C7.87618 14.0432 8.0323 14.0755 8.19062 14.0612C8.34895 14.0469 8.5025 13.9865 8.63221 13.8876L15.2377 8.84469C15.4283 8.69829 15.6574 8.92735 15.5115 9.11857L10.4686 15.7229C10.3697 15.8526 10.3094 16.0061 10.2951 16.1645C10.2808 16.3228 10.3131 16.4789 10.3881 16.6134L13.3697 21.9721C13.7775 22.704 14.8879 22.5675 15.2014 21.7461L22.1985 3.4076C22.5076 2.59831 21.7596 1.85026 20.9497 2.15882L2.6118 9.15652Z"
      fill="#6B7280"
    />
  ),
  "icon-minus": <path d="M4 12L20 12" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />,
  "icon-chat": (
    <>
      <path
        d="M4 12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V12C20 16.4183 16.4183 20 12 20H6C4.89543 20 4 19.1046 4 18V12Z"
        stroke="#6B7280"
        strokeWidth="2"
      />
      <circle cx="8" cy="12" r="1" fill="#6B7280" />
      <circle cx="12" cy="12" r="1" fill="#6B7280" />
      <circle cx="16" cy="12" r="1" fill="#6B7280" />
    </>
  ),
  "icon-pause": (
    <>
      <path d="M16 4L16 20" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 4L8 20" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  "icon-play": (
    <path
      d="M18.5 11.134C19.1667 11.5189 19.1667 12.4811 18.5 12.866L6.5 19.7942C5.83333 20.1791 5 19.698 5 18.9282L5 5.0718C5 4.302 5.83334 3.82087 6.5 4.20577L18.5 11.134Z"
      stroke="#6B7280"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  ),
  "icon-double-quotation-marks": (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.93688 4.91038C6.36917 4.80677 5.80112 5.09301 5.54631 5.61108L2.52371 11.7565C2.05109 12.4958 1.77777 13.3706 1.77777 14.3081C1.77777 16.9611 3.9666 19.1118 6.66666 19.1118C9.36672 19.1118 11.5555 16.9611 11.5555 14.3081C11.5555 11.897 9.74774 9.90079 7.39134 9.55675L7.97132 6.40945C8.10033 5.70935 7.6372 5.03819 6.93688 4.91038Z"
        fill="#7A34F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6036 4.90995C17.0359 4.80635 16.4678 5.09258 16.213 5.61065L13.1904 11.756C12.7178 12.4954 12.4445 13.3701 12.4445 14.3076C12.4445 16.9607 14.6333 19.1114 17.3333 19.1114C20.0334 19.1114 22.2222 16.9607 22.2222 14.3076C22.2222 11.8966 20.4144 9.90036 18.058 9.55633L18.638 6.40902C18.767 5.70892 18.3039 5.03777 17.6036 4.90995Z"
        fill="#7A34F4"
      />
    </>
  ),
  "icon-ai_image-gradient": (
    <>
      <path d="M9.75 18H4.5C4.10218 18 3.72064 17.842 3.43934 17.5607C3.15804 17.2794 3 16.8978 3 16.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H16.5C16.8978 3 17.2794 3.15804 17.5607 3.43934C17.842 3.72064 18 4.10218 18 4.5V9" stroke="url(#paint0_linear_5426_4587)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.3733 16.9512C11.8756 16.8633 11.8756 16.1367 12.3733 16.0488C13.2545 15.8928 14.0702 15.4736 14.7162 14.8445C15.3622 14.2155 15.8093 13.4051 16.0005 12.5167L16.0303 12.3768C16.1381 11.8766 16.8385 11.8737 16.9506 12.3725L16.9874 12.5354C17.186 13.4198 17.6372 14.2248 18.2843 14.8494C18.9314 15.474 19.7456 15.8902 20.6246 16.0459C21.1251 16.1353 21.1251 16.8647 20.6246 16.9541C19.7455 17.1096 18.9312 17.5258 18.2841 18.1504C17.637 18.775 17.1858 19.5801 16.9874 20.4646L16.9506 20.6275C16.8385 21.1263 16.1381 21.1234 16.0303 20.6232L16.0005 20.4833C15.8093 19.5949 15.3622 18.7845 14.7162 18.1555C14.0702 17.5264 13.2545 17.1072 12.3733 16.9512Z" stroke="url(#paint1_linear_5426_4587)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7 14.0001C7.5 11.831 9 9.50009 13 10.0001" stroke="url(#paint2_linear_5426_4587)" stroke-width="2" stroke-linecap="round" />
      <defs>
        <linearGradient id="paint0_linear_5426_4587" x1="3" y1="10.5" x2="18" y2="10.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A734F4" />
          <stop offset="0.875" stop-color="#640CE8" />
        </linearGradient>
        <linearGradient id="paint1_linear_5426_4587" x1="12" y1="16.5" x2="21" y2="16.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A734F4" />
          <stop offset="0.875" stop-color="#640CE8" />
        </linearGradient>
        <linearGradient id="paint2_linear_5426_4587" x1="7" y1="11.9659" x2="13" y2="11.9659" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A734F4" />
          <stop offset="0.875" stop-color="#640CE8" />
        </linearGradient>
      </defs>
    </>
  ),
  "icon-ai_image": (
    <>
      <path d="M9.75 18H4.5C4.10218 18 3.72064 17.842 3.43934 17.5607C3.15804 17.2794 3 16.8978 3 16.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H16.5C16.8978 3 17.2794 3.15804 17.5607 3.43934C17.842 3.72064 18 4.10218 18 4.5V9" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.3733 16.9512C11.8756 16.8633 11.8756 16.1367 12.3733 16.0488C13.2545 15.8928 14.0702 15.4736 14.7162 14.8445C15.3622 14.2155 15.8093 13.4051 16.0005 12.5167L16.0303 12.3768C16.1381 11.8766 16.8385 11.8737 16.9506 12.3725L16.9874 12.5354C17.186 13.4198 17.6372 14.2248 18.2843 14.8494C18.9314 15.474 19.7456 15.8902 20.6246 16.0459C21.1251 16.1353 21.1251 16.8647 20.6246 16.9541C19.7455 17.1096 18.9312 17.5258 18.2841 18.1504C17.637 18.775 17.1858 19.5801 16.9874 20.4646L16.9506 20.6275C16.8385 21.1263 16.1381 21.1234 16.0303 20.6232L16.0005 20.4833C15.8093 19.5949 15.3622 18.7845 14.7162 18.1555C14.0702 17.5264 13.2545 17.1072 12.3733 16.9512Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7 14C7.5 11.8309 9 9.5 13 10" stroke="#6B7280" stroke-width="2" stroke-linecap="round" />
    </>
  ),
  "icon-thumbs-up": (
    <>
      <path
        d="M8 20H6C4.89543 20 4 19.1046 4 18V13C4 11.8954 4.89543 11 6 11H7.63636"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5704 4.91518L8.15546 10.6772C8.05285 10.922 8 11.1848 8 11.4502V18C8 19.1046 8.89543 20 10 20H17.0533C18.0099 20 18.8389 19.3241 19.0603 18.3936C19.654 15.8985 20.4602 12.6585 19.6728 11.0481C19.1952 10.0714 17.7163 9.79402 16.2702 9.80208C15.0046 9.80913 13.8364 8.86922 13.8364 7.6036V6.07478C13.8364 4.47952 12.6865 4.05916 11.81 4.0061C11.2389 3.97152 10.7916 4.3875 10.5704 4.91518Z"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </>
  ),
  "icon-thumbs-down": (
    <>
      <path
        d="M16 4H18C19.1046 4 20 4.89543 20 6V11C20 12.1046 19.1046 13 18 13H16.3636"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4296 19.0848L15.8445 13.3228C15.9472 13.078 16 12.8152 16 12.5498V6C16 4.89543 15.1046 4 14 4H6.94666C5.99011 4 5.16114 4.67586 4.9397 5.60643C4.34598 8.10146 3.53975 11.3415 4.32721 12.9519C4.80478 13.9286 6.28371 14.206 7.7298 14.1979C8.99541 14.1909 10.1636 15.1308 10.1636 16.3964V17.9252C10.1636 19.5205 11.3135 19.9408 12.19 19.9939C12.7611 20.0285 13.2084 19.6125 13.4296 19.0848Z"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </>
  ),
  "icon-share": (
    <>
      <circle cx="18" cy="5" r="2" stroke="#6B7280" stroke-width="2" />
      <circle cx="6" cy="12" r="2" stroke="#6B7280" stroke-width="2" />
      <circle cx="18" cy="19" r="2" stroke="#6B7280" stroke-width="2" />
      <path d="M16 6L7 11" stroke="#6B7280" stroke-width="2" />
      <path d="M7 13L16 18" stroke="#6B7280" stroke-width="2" />
    </>
  ),
  "icon-dashboard": (
    <>
      <rect x="2" y="2" width="9" height="10" rx="1" stroke="#374151" strokeWidth="2" strokeLinejoin="round" />
      <rect x="2" y="16" width="9" height="6" rx="1" stroke="#374151" strokeWidth="2" strokeLinejoin="round" />
      <rect x="15" y="2" width="7" height="7" rx="1" stroke="#374151" strokeWidth="2" strokeLinejoin="round" />
      <rect x="15" y="13" width="7" height="9" rx="1" stroke="#374151" strokeWidth="2" strokeLinejoin="round" />
    </>
  ),
};

function isIconClassType(value: any): value is IconClassType {
  return value in IconDict;
}

type IconClassType = keyof typeof IconDict;

export { IconDict, isIconClassType };
export type { IconClassType };
